import { Box, MenuItem } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { Menu, MenuButton } from '@retail/components';
import { ChevronDownIcon, ChevronUpIcon } from '@sanity/icons';

interface Props {
  exportDataAsCsv?: () => void;
  exportDataAsExcel?: () => void;
  height?: number;
}

export const ExportMenu = ({ height = 42, exportDataAsCsv, exportDataAsExcel }: Props) => {
  const t = useAppTFunction();

  return (
    <Menu>
      {({ isOpen, onClose }) => (
        <Box>
          <MenuButton
            size="small"
            variant="outlined"
            color="secondary"
            endIcon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          >
            {t('calculus.actions.export')}
          </MenuButton>

          {exportDataAsCsv && (
            <MenuItem
              key="csv"
              onClick={() => {
                exportDataAsCsv();
                onClose();
              }}
              sx={{
                backgroundColor: 'grey.300',
              }}
            >
              {t('export.csv')}
            </MenuItem>
          )}

          {exportDataAsExcel && (
            <MenuItem
              key="excel"
              onClick={() => {
                exportDataAsExcel();
                onClose();
              }}
              sx={{
                backgroundColor: 'grey.300',
              }}
            >
              {t('export.excel')}
            </MenuItem>
          )}
        </Box>
      )}
    </Menu>
  );
};
